(function () {
  'use strict';

  if (typeof window === 'undefined' || !document.body) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ─────────────────────────────────────────────────────────
     1. Fade-in + slide-up on sections entering the viewport
     ───────────────────────────────────────────────────────── */
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('dg-reveal--visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -80px 0px'
      }
    );

    function tagAndObserve() {
      var selectors = [
        '[class*="section-deer-golf-"]',
        '.dg-rich__subsection',
        '.dg-showcase__card',
        '.dg-faq__item',
        '.dg-faq__group-heading'
      ];
      document.querySelectorAll(selectors.join(',')).forEach(function (el) {
        if (el.classList.contains('dg-reveal')) return;
        el.classList.add('dg-reveal');
        revealObserver.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tagAndObserve);
    } else {
      tagAndObserve();
    }
    document.addEventListener('shopify:section:load', tagAndObserve);
  }

  /* ─────────────────────────────────────────────────────────
     2. Subtle parallax on hero images
     ───────────────────────────────────────────────────────── */
  var heroParallaxTargets = [];

  function gatherParallaxTargets() {
    heroParallaxTargets = [];
    document.querySelectorAll('.dg-hero-heritage__image, .dg-hero__image').forEach(function (img) {
      heroParallaxTargets.push(img);
    });
  }

  var ticking = false;
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        var scrollY = window.scrollY || window.pageYOffset;
        for (var i = 0; i < heroParallaxTargets.length; i++) {
          var img = heroParallaxTargets[i];
          var rect = img.getBoundingClientRect();
          if (rect.bottom > 0 && rect.top < window.innerHeight) {
            var offset = scrollY * 0.18;
            img.style.transform = 'translate3d(0, ' + offset.toFixed(2) + 'px, 0) scale(1.08)';
          }
        }
        ticking = false;
      });
      ticking = true;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gatherParallaxTargets);
  } else {
    gatherParallaxTargets();
  }
  document.addEventListener('shopify:section:load', gatherParallaxTargets);

  window.addEventListener('scroll', onScroll, { passive: true });
})();
